import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const JobsLayout = lazy(() => import('@/pages/jobs/layout'));
const JobDetailLayout = lazy(() => import('@/pages/jobs/detail/layout'));
const JobsListPage = lazy(() => import('@/pages/jobs'));
const JobViewPage = lazy(() => import('@/pages/jobs/detail/view'));
const JobCreatePage = lazy(() => import('@/pages/jobs/create'));
const JobUpdatePage = lazy(() => import('@/pages/jobs/detail/update'));
const JobQcReportsPage = lazy(() => import('@/pages/jobs/detail/qcReports'));
const JobAwaPage = lazy(() => import('@/pages/jobs/detail/awa'));
const JobHistoryPage = lazy(() => import('@/pages/jobs/detail/history'));

/**
 * UG-4502 — job entity routes (legacy `app/(dashboard)/jobs/*`).
 * `JobsLayout` mounts the section breadcrumb; `JobDetailLayout` is the legacy
 * `[jobId]/layout.tsx` shell (job fetch + header + sub-page nav) around every
 * nested page. Permissions: `@/config/auth/routeAccess` (`/jobs` subtree under
 * `jobs.view`, `/jobs/[jobId]/awa` additionally under `awaResponse.view` —
 * ported 1:1 from the legacy table).
 */
export const jobRoutes: RouteConfig = {
  path: '/jobs',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      layout: JobsLayout,
      children: [
        { path: '', element: JobsListPage },
        { path: '/create', element: JobCreatePage },
        {
          path: '/:jobId',
          layout: JobDetailLayout,
          children: [
            { path: '/view', element: JobViewPage },
            { path: '/update', element: JobUpdatePage },
            { path: '/awa', element: JobAwaPage },
            { path: '/qc-reports', element: JobQcReportsPage },
            { path: '/history', element: JobHistoryPage },
          ],
        },
      ],
    },
  ],
};
